import { memo } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { useTranslation } from "react-i18next";
import { FaLanguage } from "react-icons/fa";

// A dropdown button to select a language
const LanguagesButton = ({ theme }) => {
  const { t, i18n } = useTranslation();

  // This function updates the app language and the local storage with the newly selected language
  const languageUpdater = (selectedOption) => {
    i18n.changeLanguage(selectedOption);
    window.localStorage.setItem("language", selectedOption);
  };

  return (
    <>
      <Dropdown onSelect={(selectedOption) => languageUpdater(selectedOption)}>
        <Dropdown.Toggle variant={theme === "dark" ? "dark" : "light"} style={{ transition: "1s" }}>
          <FaLanguage className="fs-3 mb-1 me-1" />
          {t("languages")}
        </Dropdown.Toggle>

        <Dropdown.Menu variant={theme === "dark" ? "dark" : "light"}>
          <Dropdown.Item eventKey="en">English</Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item eventKey="fa">فارسی</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default memo(LanguagesButton);
